import React, { useCallback } from 'react';
import styles from './styles/navbar.ms.options.vehicle.module.scss';
import { prettifyNumber } from 'helpers';
import { useDispatch, useSelector } from 'react-redux';
import {
  SetUpdateMarketScanPopup,
  SetPolicyDetailsSection,
} from 'actions/navbar-actions';
import { IAppState } from 'types';
import classNames from 'classnames';

interface INavBarMarkScanOptionsProps {
  policySubTypeName: string;
  excess?: number;
  amount?: number;
  excessContents?: number | boolean;
  amountContents?: number | boolean;
  excessHome?: number | boolean;
  amountHome?: number | boolean;
  thirdPartyScan: boolean;
  showCoverType: boolean;
}

const NavBarMarkScanOptions = ({
  policySubTypeName,
  excess,
  amount,
  thirdPartyScan,
  showCoverType,
  excessContents,
  amountContents,
  excessHome,
  amountHome,
}: INavBarMarkScanOptionsProps) => {
  const dispatch = useDispatch();

  const isDetailsPopup = useSelector(
    (state: IAppState) => state.navBar.showPolicyDetails,
  );

  const toggleVehicleDetailsPanel = useCallback(() => {
    dispatch(SetPolicyDetailsSection(!isDetailsPopup));
  }, [isDetailsPopup]);

  const openUpdateMarketScanDetailsPopup = useCallback(() => {
    dispatch(SetPolicyDetailsSection(true));
    dispatch(SetUpdateMarketScanPopup(true));
  }, []);

  return (
    <div className={styles.container}>
      {showCoverType && (
        <div
          className={styles.section}
          onClick={openUpdateMarketScanDetailsPopup}
        >
          <span className={styles.label}>Cover Type:</span>{' '}
          <span className={styles.link}>{policySubTypeName}</span>
        </div>
      )}

      {!thirdPartyScan && amount && (
        <div
          className={styles.section}
          onClick={openUpdateMarketScanDetailsPopup}
        >
          <span className={styles.label}>Preferred Sum Insured:</span>{' '}
          <span className={styles.link}>{`$${prettifyNumber(amount)}`}</span>
        </div>
      )}

      {excess && (
        <div
          className={styles.section}
          onClick={openUpdateMarketScanDetailsPopup}
        >
          <span className={styles.label}>Preferred Excess:</span>{' '}
          <span className={styles.link}>{`$${prettifyNumber(excess)}`}</span>
        </div>
      )}

      {amountHome && (
        <div
          className={styles.section}
          onClick={openUpdateMarketScanDetailsPopup}
        >
          <span className={styles.label}>House Sum Insured:</span>{' '}
          <span
            className={styles.link}
          >{`$${prettifyNumber(amountHome)}`}</span>
        </div>
      )}

      {amountContents && (
        <div
          className={styles.section}
          onClick={openUpdateMarketScanDetailsPopup}
        >
          <span className={styles.label}>Contents Sum Insured:</span>{' '}
          <span
            className={styles.link}
          >{`$${prettifyNumber(amountContents)}`}</span>
        </div>
      )}

      {excessHome && (
        <div
          className={styles.section}
          onClick={openUpdateMarketScanDetailsPopup}
        >
          <span className={styles.label}>House Excess:</span>{' '}
          <span
            className={styles.link}
          >{`$${prettifyNumber(excessHome)}`}</span>
        </div>
      )}

      {excessContents && (
        <div
          className={styles.section}
          onClick={openUpdateMarketScanDetailsPopup}
        >
          <span className={styles.label}>Contents Excess:</span>{' '}
          <span
            className={styles.link}
          >{`$${prettifyNumber(excessContents)}`}</span>
        </div>
      )}

      <div
        className={classNames(
          styles.moreInfoSection,
          !showCoverType && styles.section,
        )}
        onClick={toggleVehicleDetailsPanel}
      >
        <span className={classNames(styles.link, styles.moreInfoText)}>
          {isDetailsPopup ? 'Less info' : 'More info'}
        </span>
      </div>
    </div>
  );
};

export default NavBarMarkScanOptions;
